import { takeLatest as takeLatestSaga, select, put } from 'redux-saga/effects';
import jsCookie from 'js-cookie';

import * as sagas from '../helpers/sagas';
import { merge } from '../helpers/array';

import { types } from '../actions/app';
import { types as typesTara } from '../actions/tara';
import {
  ANALYTICS_PAGEVIEW,
  ANALYTICS_NEW_SESSION,
} from '../actions/analytics/types';
import { api } from '../resources/app';
import * as routeTypes from '../routes/types';
import { handlerTypes } from '../reducers/app/title';
import { getAppWindowTitle } from '../reducers/app/title';

const takeLatest = [
  {
    type: types.APP_LOGIN,
    call: api.login,
  },
];

const handleAppSetSessionId = function* (action) {
  yield jsCookie.set('sessionId', action.payload.sessionId, { expires: 365 });
};

const handleNewSessionSuccess = function* (action) {
  yield jsCookie.set('sessionId', action.payload.data.sessionId, { expires: 365 });
};

const handleTaraSurvey = function* (action) {
  yield jsCookie.set('surveyCompleted', true, { expires: 365 });
};

const handleRouteChange = function* (action) {
  const title = yield select(getAppWindowTitle);

  if (window.document) {
    window.document.title = title;
  }

  if (action.type.indexOf('route/') === 0) {
    const { pathname } = action.meta.location.current;

    const analyticsPageView = {
      type: ANALYTICS_PAGEVIEW,
      payload: {
        page_path: pathname,
        page_title: title,
      },
    };

    yield put(analyticsPageView);
  }
};


let routeTypesArray = Object.keys(routeTypes).map(type => routeTypes[type]);
routeTypesArray = merge(routeTypesArray, handlerTypes);

const takeLatestSideEffects = [
  ...routeTypesArray.map(type => takeLatestSaga(type, handleRouteChange)),
  takeLatestSaga(types.APP_SET_SESSION_ID, handleAppSetSessionId),
  takeLatestSaga(ANALYTICS_NEW_SESSION.SUCCESS, handleNewSessionSuccess),

  takeLatestSaga(typesTara.TARA_POST_SURVEY.SUCCESS, handleTaraSurvey),
  takeLatestSaga(typesTara.TARA_POST_SURVEY.FAILURE, handleTaraSurvey),
];

const app = takeLatest.map(sagas.makeTakeLatest).concat(takeLatestSideEffects);

export default app;



// WEBPACK FOOTER //
// ./src/sagas/app.js